import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList } from "vue"

const _hoisted_1 = {
  class: "flex flex-col gap-4 text-left",
  "data-testid": "unidentified-coverage-details"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "grid grid-cols-2 md:grid-cols-4 gap-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Time"),
  /*#__PURE__*/_createElementVNode("span", null, "Externo")
], -1)
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Posição", -1)
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Turno", -1)
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Valor de referência", -1)
const _hoisted_13 = { "data-testid": "unidentified-reference-value" }
const _hoisted_14 = ["data-testid"]
const _hoisted_15 = { class: "text-sm font-bold text-gray-500" }
const _hoisted_16 = { class: "text-sm text-gray-500" }

import UnidentifiedCoverageCard from '@/components/Coverage/UnidentifiedCoverageCard.vue'
import { formatCurrencyOrDash } from '@/utils/formatters'


export default /*#__PURE__*/_defineComponent({
  __name: 'UnidentifiedCoverageDetails',
  props: {
    responsibleName: { default: null },
    note: { default: null },
    stationTypeLabel: { default: null },
    positionName: { default: null },
    shiftName: { default: null },
    referenceValue: {},
    showActions: { type: Boolean },
    canIdentify: { type: Boolean },
    canEditResponsible: { type: Boolean },
    canRelease: { type: Boolean },
    actionsDisabled: { type: Boolean, default: false },
    reserveActionsLane: { type: Boolean, default: false }
  },
  emits: ["identify", "editResponsible", "release"],
  setup(__props: any, { emit }) {





const LOCKED_SECTIONS = [
  {
    testId: 'unidentified-locked-registration',
    title: 'Registro de plantão (check-in / check-out)',
    text: 'Bloqueado: não há médico para registrar ponto. Identifique o médico para liberar.'
  },
  {
    testId: 'unidentified-locked-activity',
    title: 'Registro de Atividade',
    text: 'Bloqueado: sem cobrança de envio e sem vínculo de folha enquanto sem identificação.'
  },
  {
    testId: 'unidentified-locked-post-station',
    title: 'Pós-plantão',
    text: 'Não avaliado: plantões sem identificação ficam fora do pós-plantão e do NPS.'
  }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex flex-col gap-4", _ctx.reserveActionsLane ? 'md:pr-[calc(2.5vw_+_32px)]' : '']),
      "data-testid": "unidentified-actions-lane"
    }, [
      _createVNode(UnidentifiedCoverageCard, {
        "responsible-name": _ctx.responsibleName,
        note: _ctx.note,
        "station-type-label": _ctx.stationTypeLabel
      }, {
        default: _withCtx(() => [
          (_ctx.showActions)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.canIdentify)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "rounded-md bg-primary px-3 py-1.5 text-sm font-semibold text-white disabled:opacity-50 disabled:cursor-not-allowed",
                      disabled: _ctx.actionsDisabled,
                      "data-testid": "unidentified-identify-button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('identify')))
                    }, " Identificar médico ", 8, _hoisted_2))
                  : _createCommentVNode("", true),
                (_ctx.canEditResponsible)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "rounded-md border border-solid border-primary30 bg-white px-3 py-1.5 text-sm font-semibold text-primary30 disabled:opacity-50 disabled:cursor-not-allowed",
                      disabled: _ctx.actionsDisabled,
                      "data-testid": "unidentified-edit-responsible-button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('editResponsible')))
                    }, " Editar responsável ", 8, _hoisted_3))
                  : _createCommentVNode("", true),
                (_ctx.canRelease)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: "ml-auto rounded-md border border-solid border-negative bg-white px-3 py-1.5 text-sm font-semibold text-negative disabled:opacity-50 disabled:cursor-not-allowed",
                      disabled: _ctx.actionsDisabled,
                      "data-testid": "unidentified-release-button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('release')))
                    }, " Liberar vaga ", 8, _hoisted_4))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["responsible-name", "note", "station-type-label"]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("span", null, _toDisplayString(_ctx.positionName || 'Não definida'), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("span", null, _toDisplayString(_ctx.shiftName || 'Não definido'), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(formatCurrencyOrDash)(_ctx.referenceValue)) + " (fora dos totais)", 1)
        ])
      ])
    ], 2),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(LOCKED_SECTIONS, (section) => {
      return _createElementVNode("section", {
        key: section.testId,
        class: "rounded-lg border border-dashed border-lightGray30 bg-[#FAFAFB] px-3 py-2.5",
        "data-testid": section.testId
      }, [
        _createElementVNode("p", _hoisted_15, _toDisplayString(section.title), 1),
        _createElementVNode("p", _hoisted_16, _toDisplayString(section.text), 1)
      ], 8, _hoisted_14)
    }), 64))
  ]))
}
}

})